import { createContext, useContext } from "react";

export type ToggleSwitchControllerPolicy = "exactlyOne" | "multi" | "zeroOrOne";

export interface ToggleSwitchControllerContextValue {
    register: (name: string, isDefault: boolean) => void;
    unregister: (name: string) => void;
    isRegistered: (name: string) => boolean;
    isOpen: (name: string) => boolean;
    open: (name: string) => void;
    toggle: (name: string) => void;
    /** Effective policy at the current viewport width. */
    policy: ToggleSwitchControllerPolicy;
    /**
     * Removes `name` from the open set when the effective policy is `zeroOrOne` or `multi`
     * and that switch is open. Under `exactlyOne`, or when the name is already closed,
     * this is a no-op. Never opens a switch.
     */
    close: (name: string) => void;
}

export const ToggleSwitchControllerContext = createContext<ToggleSwitchControllerContextValue | null>(null);

export function useToggleSwitchController(): ToggleSwitchControllerContextValue | null {
    return useContext(ToggleSwitchControllerContext);
}
